export default __webpack_public_path__ + "static/media/Img-promo-GORU@2x.5e07dcd8.png";